// Mirror of packages/copy/src/parcelcopy.py — same canonical constants, TS edition.
// Spec: docs/spec.md §7.A–C. ALL UI text about parcel status MUST route through here.
// Keep in sync with parcelcopy.py — CI compliance-lint scans this file too.

export const DISCLAIMER =
  "Eligibility flags are automated estimates from public data and may be " +
  "inaccurate or out of date. Live Local Act rules change frequently. " +
  "Confirm with a land-use attorney before making any offer or decision.";

const ALLOWED_LLA_PHRASES = {
  flag:     "flagged as potentially eligible",
  qualify:  "may qualify — verify with counsel",
  estimate: "automated estimate, not a legal determination",
  signal:   "potential upzone signal",
} as const;

export type FlagIntent = keyof typeof ALLOWED_LLA_PHRASES;

const FORBIDDEN: ReadonlyArray<string> = [
  "qualifies",
  "is eligible",
  "is upzonable",
  "meets criteria",
  "is approved for",
  "cleared for",
  "zoned for",
];

export class CopyComplianceError extends Error {}

export function flagPhrase(intent: FlagIntent = "flag"): string {
  const v = ALLOWED_LLA_PHRASES[intent];
  if (!v) throw new CopyComplianceError(`unknown intent: ${intent}`);
  return v;
}

export function assertCompliant(text: string): void {
  const low = text.toLowerCase();
  for (const bad of FORBIDDEN) {
    if (low.includes(bad)) {
      throw new CopyComplianceError(`forbidden phrase ${JSON.stringify(bad)} in generated text`);
    }
  }
}

export interface FlagRender {
  phrase: string;
  disclaimer: string;
  staleness: string;
}

export function renderFlag(opts: {
  asOf: string;             // YYYY-MM-DD
  rulesetVersion: string;
  intent?: FlagIntent;
}): FlagRender {
  const r: FlagRender = {
    phrase: flagPhrase(opts.intent ?? "flag"),
    disclaimer: DISCLAIMER,
    staleness: `Data as of ${opts.asOf} · Rules: ${opts.rulesetVersion}`,
  };
  assertCompliant(r.phrase);
  assertCompliant(r.disclaimer);
  assertCompliant(r.staleness);
  return r;
}
